var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { RendererFactory } from "survey-core";
import { initLogicOperator } from "survey-creator-core";
import { SurveyQuestionDropdown, ReactQuestionFactory } from "survey-react-ui";
var SurveyLogicOpertor = /** @class */ (function (_super) {
    __extends(SurveyLogicOpertor, _super);
    function SurveyLogicOpertor(props) {
        return _super.call(this, props) || this;
    }
    SurveyLogicOpertor.prototype.renderInput = function () {
        var q = this.question;
        initLogicOperator(q);
        var text = (q.locReadOnlyText) ? this.renderLocString(q.locReadOnlyText) : "";
        var dropdownListModel = this.question.dropdownListModel;
        return (React.createElement("div", { id: this.question.inputId, className: q.getControlClass(), tabIndex: this.question.isInputReadOnly ? undefined : 0, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            disabled: this.question.isInputReadOnly, required: this.question.isRequired, onChange: this.updateValueOnEvent, onInput: this.updateValueOnEvent, onKeyUp: this.keyhandler, role: dropdownListModel.ariaQuestionRole, "aria-required": dropdownListModel.ariaQuestionRequired, "aria-invalid": dropdownListModel.ariaQuestionInvalid, "aria-errormessage": dropdownListModel.ariaQuestionErrorMessage, "aria-expanded": dropdownListModel.ariaQuestionExpanded, "aria-label": dropdownListModel.ariaQuestionLabel, "aria-labelledby": dropdownListModel.ariaQuestionLabelledby, "aria-controls": dropdownListModel.ariaQuestionControls },
            React.createElement("div", { className: this.question.cssClasses.controlValue }, text)));
    };
    SurveyLogicOpertor.prototype.renderEditorButtons = function () {
        return null;
    };
    return SurveyLogicOpertor;
}(SurveyQuestionDropdown));
export { SurveyLogicOpertor };
ReactQuestionFactory.Instance.registerQuestion("sv-logic-operator", function (props) {
    return React.createElement(SurveyLogicOpertor, props);
});
RendererFactory.Instance.registerRenderer("dropdown", "logicoperator", "sv-logic-operator");
